import { ObservationConditionType } from "generated/graphql";

export const observationConditionLabelMap: Record<
  ObservationConditionType,
  string
> = {
  [ObservationConditionType.Dead]: "Dead",
  [ObservationConditionType.Good]: "Good",
  [ObservationConditionType.Fair]: "Fair",
  [ObservationConditionType.Poor]: "Poor",
};

export const observationConditionLabelDotColorMap: Record<
  ObservationConditionType,
  string
> = {
  [ObservationConditionType.Dead]: "bg-grey-400",
  [ObservationConditionType.Good]: "bg-primary-400",
  [ObservationConditionType.Fair]: "bg-warning-400",
  [ObservationConditionType.Poor]: "bg-orange-400",
};
